import React, { useState } from 'react';
import logo from '../assets/logo-dark.png';
import { useHistory } from 'react-router-dom';
import { useAuth, createSubscription } from 'api';
import { Notice } from 'ui';
import {
  Title,
  Input,
  Text,
  Button,
  CheckoutForm,
} from 'ui';


export default function AuthBilling() {
  
  const auth = useAuth();
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [error, setError] = useState("");
  
  if(!auth) {
    return null;
  }
  
  if(!auth.company || !auth.company.id) {
    return <Notice text="No company found."/>;
  }
  
  if(!auth.company.plan) {
    return <Notice text="No company plan found."/>;
  }
  
  async function submit(token) {
    setSubmitting(true);
    setError("");
    try {
      await createSubscription({
        companyId: auth.company.id,
        planId: auth.company.plan.id,
        coupon,
        token, 
      });
    }
    catch(error) {
      setSubmitting(false);
      setError(error.message || "Something went wrong. Please try again.");
      return;
    }
    history.push('/');
  }
  
  return (
    <div className="auth-screen">
      <img src={logo} alt="Taptivate" className="auth-logo"/>
      
      <Title className="auth-title">
        Payment<br/>
        <br/>
      </Title>
      
      <Text color="red" className="auth-error">{error || ""}</Text>
      
      <div className="auth-2col">
        
        <div className="auth-card">
          <CheckoutForm onSubmit={submit} submitting={submitting}/>
        </div>
        
        <div className="auth-card">
          <Title>{auth.company.plan.name} Plan</Title>
          <Text block style={{marginBottom:8}}>${auth.company.plan.cost/100}.00 / {auth.company.plan.cycle}</Text>
          <Text block small style={{marginBottom:8}}>Your receipt will be sent to {auth.company.email}</Text>
          <Button tertiary to="plan" style={{marginBottom:40}}>
            <Text orange small>Change Plan</Text>
          </Button>
          
          <Title>{auth.company.name}</Title>
          <Text block style={{marginBottom:8}}>
            {auth.company.street}<br/>
            {auth.company.city} {auth.company.state} {auth.company.zip}
          </Text>
          <Button tertiary to="company" style={{marginBottom:40}}>
            <Text orange small>Change</Text>
          </Button>
          <Input outline name="coupon" label="Coupon Code" className="auth-input" value={coupon} onChange={setCoupon} style={{maxWidth:150}}/>
        </div>
        
      </div>
    </div>
  );
}
